<!-- 获取时间段进场记录接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {"parkCode":"2KNTYVWC","carNoArray":["粤YAL876","粤A66666"],"isPresence":"0","startTime":"20171015000000","endTime":"20171015141333","pageNum":"1","pageSize":"2"},
            responseCode: 	{
                "data": {
                    "currCount": 1,
                    "recordInList": [
                        {
                            "carLicenseNumber": "未识别0927092703163",
                            "confidence": 0,
                            "correctConfidence": 0,
                            "enterCarCardNumber": "",
                            "enterCarColor": 0,
                            "enterCarLicenseColor": 0,
                            "enterCarLicenseNumber": "",
                            "enterCarLicenseType": 0,
                            "enterCarLogo": 0,
                            "enterChannelName": "",
                            "enterImageArray": [
                                {
                                    "carImage": "http://221.4.168.157:13388/openydt/files/images/2017092709265304913364-body-in-nor.jpg?s=1aadff86"
                                }
                            ],
                            "enterRecognitionConfidence": 0,
                            "enterSpeed": 0,
                            "enterTime": "20170927092653",
                            "enterType": 0,
                            "enterVipType": 1,
                            "inOperatorName": "",
                            "isCorrect": 0,
                            "parkCode": "2KNTYVWC",
                            "parkName": "开发停车场2",
                            "parkingCode": "2017092709265304913364",
                            "recordType": 0
                        }
                    ],
                    "total": 600
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取指定时间段进场记录信息",
                t_url: this.commonUrls.test+"getCarInList",
                p_url: this.commonUrls.prod+"getCarInList",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'carNoArray', info2: '否', info3: 'String[]', info4: '车牌号数组，如["粤YAL123","粤WKL345"]' },
                        { info1: 'isPresence', info2: '是', info3: 'Integer', info4: '是否在场，0不区分，1在场，2不在场' },
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '时间段起始时间，yyyyMMddHHmmss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '时间段结束时间，yyyyMMddHHmmss，起始时间与结束时间不允许超过一天' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'carLicenseNumber', info2: '是', info3: 'String', info4: '最终车牌号' },
                        { info1: 'confidence', info2: '是', info3: 'Decimal', info4: '最终识别置信度' },
                        { info1: 'enterCarLicenseNumber', info2: '是', info3: 'String', info4: '进场车牌号' },
                        { info1: 'enterCarCardNumber', info2: '是', info3: 'String', info4: '进场卡号' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间，yyyyMMddHHmmss' },
                        { info1: 'enterChannelName', info2: '是', info3: 'String', info4: '进场通道名' },
                        { info1: 'enterVipType', info2: '是', info3: 'Integer', info4: '进场VIP类型，0未定义，1普通，2本地VIP，3外部VIP，4黑名单，5访客' },
                        { info1: 'enterType', info2: '是', info3: 'Integer', info4: '进场放行类型，0未确认，1自动放行，2确认放行，3异常放行，4 遥控开闸、99 虚拟进场' },
                        { info1: 'enterSpeed', info2: '是', info3: 'Decimal', info4: '进场速度' },
                        { info1: 'enterCarLicenseColor', info2: '是', info3: 'Integer', info4: '进场车牌颜色（0未定义，1蓝色，2黄色，3白色，4黑色，5绿色）' },
                        { info1: 'enterCarColor', info2: '是', info3: 'Integer', info4: '进场车辆颜色（0未定义，1白色,2黑色,3红色,4绿色,5粉色,6蓝色,7紫色，8灰色,9雪青，10葱绿，11黄色，12橙色）' },
                        { info1: 'enterCarLogo', info2: '是', info3: 'Integer', info4: '进场车标' },
                        { info1: 'enterCarLicenseType', info2: '是', info3: 'Integer', info4: '进场车牌类型（0未定义，1蓝牌白字，2黄牌黑字，3黑牌白字，4白牌）' },
                        { info1: 'enterCarType', info2: '是', info3: 'Integer', info4: '车辆类型（0未知，1小车，2大车，3超大车，4中型车）' },
                        { info1: 'enterRecognitionConfidence', info2: '是', info3: 'Decimal', info4: '进场识别置信度' },
                        { info1: 'recordType', info2: '是', info3: 'Integer', info4: '记录类型（0未定义，1有牌车，2无牌车，3遮挡车，4非汽车，5误触发）' },
                        { info1: 'isCorrect', info2: '是', info3: 'Integer', info4: '车牌是否被纠正（0未纠正，1已纠正）' },
                        { info1: 'correctConfidence', info2: '是', info3: 'Decimal', info4: '校正置信度' },
                        { info1: 'correctType', info2: '是', info3: 'Integer', info4: '校正类型（0未校正，1手动校正，2自动校正）' },
                        { info1: 'lastCorrectLicenseNumber', info2: '是', info3: 'String', info4: '最后校正校正车牌' },
                        { info1: 'lastCorrectName', info2: '是', info3: 'String', info4: '最后校正人名' },
                        { info1: 'lastCorrectTime', info2: '是', info3: 'String', info4: '最后校正时间，yyyyMMddHHmmss' },
                        { info1: 'remark', info2: '是', info3: 'String', info4: '备注' },
                        { info1: 'inOperatorName', info2: '是', info3: 'String', info4: '进场放行操作员' },
                        { info1: 'inOperateTime', info2: '是', info3: 'String', info4: '进场放行时间，yyyyMMddHHmmss' },
                        { info1: 'enterCustomVipName', info2: '是', info3: 'String', info4: '进场VIP名称' },
                        { info1: 'enterImageArray', info2: '是', info3: 'JSONArray', info4: '进场图片列表[{"carImage"："车身图片直接访问url"}]<br>'  + '注：智汇云不提供车牌图片' },
                        { info1: 'enterNovipCode', info2: '是', info3: 'Integer', info4: '进场说明（<url>参考附录:/Api/appendixData</url>）' },

                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/getCarInList.vue